// @flow
import type { LeafRuleProps } from 'types/rule-types';

import classnames from 'classnames';
import _ from 'lodash';
import React, { Component } from 'react';
import { Dropdown } from 'semantic-grab-ui/src';
import {
  operatorOptions,
} from 'omega-rtc/components/rule-builder/utils';

export const DAYS_OF_WEEK = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
export default class DayRule extends Component {
  props: LeafRuleProps;

  constructor(props: LeafRuleProps) {
    super(props);
    this.state = {
      rhs: _.get(props, 'rule.rhs'),
    };
  }

  handleRuleOperatorSelect = (event: Object, dropdown: Object) => {
    const { rule } = this.props;
    const newRule = Object.assign({}, rule, { operator: dropdown.value });
    this.props.onRuleChange(newRule);
  }

  handleRhsChangeDay = (day: any) => {
    if (!this.props.isSelected) return;

    const { rule } = this.props;
    const { rhs: days } = rule;
    if (days.indexOf(day) > -1) {
      days.splice(days.indexOf(day), 1);
    } else {
      days.push(day);
    }
    this.props.onRuleChange(rule);
  }

  render() {
    const { rule, ruleType, isSelected } = this.props;
    return (
      <span>
        <span>{ruleType.noun}</span>
        <span className="horizontal-margin">
          <Dropdown
            inline
            options={operatorOptions(ruleType)}
            defaultValue={rule.operator}
            onChange={this.handleRuleOperatorSelect}
            disabled={!isSelected}
          />
        </span>
        <span>
          {
            DAYS_OF_WEEK.map((day, index) => (
              <span
                key={day}
                className={classnames('day-pill', { selected: rule.rhs.indexOf(index) > -1 })}
                onClick={() => this.handleRhsChangeDay(index)}
              >
                {day}
              </span>
            ))
          }
        </span>
      </span>
    );
  }
}
